import { LazyQueryResultTuple, useLazyQuery, OperationVariables } from '@apollo/client';
import { GET_TIMESHEET_BY_FOREMAN } from '@bechtel/client-gql';
import { TimesheetDay } from '@bechtel/types';

export function useTimesheetByForeman(
  fetchFromNetwork?: boolean
): LazyQueryResultTuple<{ timesheetByForeman: TimesheetDay }, OperationVariables> {
  const response = useLazyQuery<
    {
      timesheetByForeman: TimesheetDay;
    },
    OperationVariables
  >(
    GET_TIMESHEET_BY_FOREMAN,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
